import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    newPath: String
  }

  connect() {
    this.boundOnFrameLoad = this.onFrameLoad.bind(this)
  }

  open(event) {
    event?.preventDefault()

    const frame = document.getElementById("feedback_modal")
    if (!frame) return

    const loaded = frame.querySelector("#feedback_modal_content") !== null
    if (loaded) {
      this.dispatchOpen()
      return
    }

    this.setLoading(true)
    frame.setAttribute("src", this.newPathValue)
    frame.dataset.feedbackPendingOpen = "true"
    frame.addEventListener("turbo:frame-load", this.boundOnFrameLoad, { once: true })
  }

  onFrameLoad() {
    this.setLoading(false)
    const frame = document.getElementById("feedback_modal")
    if (frame) delete frame.dataset.feedbackPendingOpen
  }

  dispatchOpen() {
    document.dispatchEvent(new CustomEvent("feedback:open"))
  }

  setLoading(loading) {
    const button = this.element
    if (!(button instanceof HTMLButtonElement)) return

    if (loading) {
      button.disabled = true
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.innerHTML
      }
      button.innerHTML = "Загрузка…"
    } else {
      button.disabled = false
      if (button.dataset.originalText) {
        button.innerHTML = button.dataset.originalText
      }
    }
  }
}
